// Shared types, validators, and constants
export function isActiveResource(user) {
    return user.is_active !== false;
}
// === Jira Field Utility Functions ===
/** Extract plain text from Jira Atlassian Document Format (ADF) */
export function extractTextFromADF(adf) {
    if (!adf || typeof adf !== 'object')
        return '';
    const doc = adf;
    if (!doc.content)
        return '';
    const texts = [];
    const walk = (nodes) => {
        for (const node of nodes) {
            const n = node;
            if (n.text)
                texts.push(n.text);
            if (n.content)
                walk(n.content);
        }
    };
    walk(doc.content);
    return texts.join('').trim();
}
/** Parse Jira duration string (e.g. "2h 30m", "1d", "1w 2d") into seconds.
 *  Uses Jira defaults: 1w = 5d, 1d = 8h. Returns null for invalid input. */
export function parseDurationToSeconds(input) {
    const cleaned = input.trim().toLowerCase();
    if (!cleaned)
        return null;
    let total = 0;
    let matched = false;
    const weekMatch = cleaned.match(/(\d+(?:\.\d+)?)\s*w/);
    const dayMatch = cleaned.match(/(\d+(?:\.\d+)?)\s*d/);
    const hourMatch = cleaned.match(/(\d+(?:\.\d+)?)\s*h/);
    const minuteMatch = cleaned.match(/(\d+(?:\.\d+)?)\s*m(?!s)/);
    if (weekMatch) {
        total += parseFloat(weekMatch[1]) * 5 * 8 * 3600;
        matched = true;
    }
    if (dayMatch) {
        total += parseFloat(dayMatch[1]) * 8 * 3600;
        matched = true;
    }
    if (hourMatch) {
        total += parseFloat(hourMatch[1]) * 3600;
        matched = true;
    }
    if (minuteMatch) {
        total += parseFloat(minuteMatch[1]) * 60;
        matched = true;
    }
    return matched && total > 0 ? Math.round(total) : null;
}
/** Convert seconds to Jira-style duration display (e.g. "2h 30m") */
export function secondsToDuration(seconds) {
    if (seconds <= 0)
        return '0m';
    const weeks = Math.floor(seconds / (5 * 8 * 3600));
    let remainder = seconds % (5 * 8 * 3600);
    const days = Math.floor(remainder / (8 * 3600));
    remainder = remainder % (8 * 3600);
    const hours = Math.floor(remainder / 3600);
    const minutes = Math.floor((remainder % 3600) / 60);
    const parts = [];
    if (weeks > 0)
        parts.push(`${weeks}w`);
    if (days > 0)
        parts.push(`${days}d`);
    if (hours > 0)
        parts.push(`${hours}h`);
    if (minutes > 0)
        parts.push(`${minutes}m`);
    return parts.join(' ') || '0m';
}
//# sourceMappingURL=index.js.map